import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg viewBox="0 0 240 200" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M107.263 97.73q0 6.798-5.015 11.557t-12.18 4.759-12.179-4.759-5.014-11.557 5.014-11.556 12.18-4.76 12.179 4.76 5.015 11.556zm91.7 32.63v38.07H72.876v-16.315l28.656-27.193 14.329 13.597 45.85-43.508 37.254 35.35zm8.598-59.822H64.278q-1.165 0-2.015.807t-.851 1.912v103.33q0 1.105.85 1.913t2.016.807H207.56q1.164 0 2.015-.807t.85-1.912V73.258q0-1.105-.85-1.913t-2.015-.807zm14.328 2.72v103.33q0 5.608-4.209 9.602t-10.12 3.994H64.279q-5.91 0-10.12-3.994t-4.209-9.602V73.258q0-5.61 4.21-9.603t10.119-3.994h35.82l35.821-.562 36.383.562h35.259q5.91 0 10.12 3.994t4.208 9.602z" />
        <path d="M87.8 46.316l-66.338 27.05q-1.078.44-1.56 1.509t-.066 2.092c13.005 31.894 18.01 46.287 31.015 78.181 1.043-32.982 4.087-57.965 5.13-89.948l117.774-4.135-15.935-40.363q-.417-1.023-1.51-1.45L87.8 46.316l66.34-27.05L87.8 46.316zm80.634-29.942c6.502 15.78 17.505 37.56 24.008 53.34-43.166.983-92.332-5.035-135.498-4.553l2.694 114.995q1.527 6.232-3.878 4.123t-7.523-7.303L9.221 81.295q-2.117-5.193.272-10.48t7.863-7.52L50.525 49.77l32.957-14.046 33.902-13.217 32.649-13.313q5.473-2.232 10.878-.123t7.523 7.303z" />
      </g>
    </svg>
  );
};

export default SvgComponent;
